import { c as _c } from "react/compiler-runtime";
import styles from './Table.module.css';
function Row(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <tr className={styles.row}>{children}</tr>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default Row;